import React, { useEffect, useRef } from 'react';

const CanvasDotsAnimation = () => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');

    // Set canvas dimensions to full viewport
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;

    // Create an array to store multiple dots
    const dots = [];
    const numDots = 25; // Number of dots

    // Function to create a dot
    const createDot = () => {
      return {
        x: Math.random() * canvas.width, // Random horizontal position
        y: Math.random() * canvas.height, // Random vertical position
        radius: Math.random() * 3 + 1, // Random size (1 to 4px)
        xSpeed: (Math.random() - 0.5) * 1, // Random horizontal speed (-1 to 1)
        ySpeed: (Math.random() - 0.5) * 1, // Random vertical speed (-1 to 1)
        color: `rgb(${Math.random() * 255}, ${Math.random() * 255}, ${Math.random() * 255})`, // Random color
      };
    };

    // Initialize the dots
    for (let i = 0; i < numDots; i++) {
      dots.push(createDot());
    }

    const animate = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height); 

      dots.forEach((dot) => {
        // Draw the dot
        ctx.beginPath();
        ctx.arc(dot.x, dot.y, dot.radius, 0, Math.PI * 2);
        ctx.fillStyle = dot.color;
        ctx.fill();
        dot.x += dot.xSpeed;
        dot.y += dot.ySpeed;

        if (dot.x - dot.radius < 0 || dot.x + dot.radius > canvas.width) {
          dot.xSpeed *= -1;
        }
        if (dot.y - dot.radius < 0 || dot.y + dot.radius > canvas.height) {
          dot.ySpeed *= -1; 
        }
      });

      requestAnimationFrame(animate);
    };

    animate();

    const handleResize = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <canvas
      ref={canvasRef}
      style={{
        display: 'block',
      }}
    ></canvas>
  );
};

export default CanvasDotsAnimation;
